export default __webpack_public_path__ + "static/media/UTI-logo@2x.6a691f43.png";